import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { trackAddToCart, trackInitiateCheckout } from '../utils/pixel';
export const StickyOfferBar = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = new Date();
      const midnight = new Date(now);
      midnight.setHours(24, 0, 0, 0);
      const difference = midnight.getTime() - now.getTime();
      if (difference > 0) {
        setTimeLeft({
          hours: Math.floor(difference / (1000 * 60 * 60) % 24),
          minutes: Math.floor(difference / 1000 / 60 % 60),
          seconds: Math.floor(difference / 1000 % 60)
        });
      } else {
        setTimeLeft({
          hours: 23,
          minutes: 59,
          seconds: 59
        });
      }
    };
    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (time: number) => time.toString().padStart(2, '0');
  const handleClick = () => {
    trackAddToCart();
    trackInitiateCheckout();
    window.location.href = 'https://valordigital.store/cart/46518849142973:1';
  };
  return <AnimatePresence data-id="element-495">
      {isVisible && <motion.div initial={{
      y: '-100%'
    }} animate={{
      y: 0
    }} exit={{
      y: '-100%'
    }} transition={{
      duration: 0.3,
      ease: 'easeInOut'
    }} className="fixed top-0 left-0 right-0 z-40 bg-black py-2 px-4 shadow-md" data-id="element-496">
          <div className="max-w-6xl mx-auto flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6" data-id="element-497">
            <span className="text-white font-montserrat font-bold text-sm md:text-base text-center flex items-center gap-2 flex-wrap justify-center" data-id="element-498">
              🔥 70% OFF — $14.990
              <span className="flex items-center gap-1" data-id="element-499">
                <span className="text-white/60 text-xs" data-id="element-500">⏳</span>
                <span className="bg-white/15 rounded px-1.5 py-0.5 font-mono text-xs font-bold text-white" data-id="element-501">
                  {formatTime(timeLeft.hours)}
                </span>
                <span className="text-white/50 font-bold text-xs" data-id="element-502">:</span>
                <span className="bg-white/15 rounded px-1.5 py-0.5 font-mono text-xs font-bold text-white" data-id="element-503">
                  {formatTime(timeLeft.minutes)}
                </span>
                <span className="text-white/50 font-bold text-xs" data-id="element-504">:</span>
                <span className="bg-white/15 rounded px-1.5 py-0.5 font-mono text-xs font-bold text-white" data-id="element-505">
                  {formatTime(timeLeft.seconds)}
                </span>
              </span>
            </span>
            <button onClick={handleClick} className="bg-[#22c55e] hover:bg-[#16a34a] text-white font-montserrat font-bold text-sm py-1.5 px-4 rounded-lg transition-colors" data-id="element-506">
              ¡Descargar Ahora!
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
};